<template>

    <div class="hc">

        <button class="hc__btn"
                :class="{
            'hc__active': category === ENUM.NEWSLETTERS.CATEGORIES.ALL,
            'text-lMedium': category !== ENUM.NEWSLETTERS.CATEGORIES.ALL,
            'text-lSemibold': category === ENUM.NEWSLETTERS.CATEGORIES.ALL,
        }"
                @click="updateCategory(ENUM.NEWSLETTERS.CATEGORIES.ALL)">
            <p class="mr__6">{{ $t('cleaning_header_all') }}</p>
            <div class="hc__highlight">
                <p class="text-baseMedium">{{ countTotal }}</p>
            </div>
        </button>

        <button class="hc__btn"
                :class="{
            'hc__active': category === ENUM.NEWSLETTERS.CATEGORIES.SUBSCRIPTIONS,
            'text-lMedium': category !== ENUM.NEWSLETTERS.CATEGORIES.SUBSCRIPTIONS,
            'text-lSemibold': category === ENUM.NEWSLETTERS.CATEGORIES.SUBSCRIPTIONS,
        }"
                @click="updateCategory(ENUM.NEWSLETTERS.CATEGORIES.SUBSCRIPTIONS)">
            <p class="mr__6">{{ $t('cleaning_title') }}</p>
            <div class="hc__highlight">
                <p class="text-baseMedium">{{ countNewsletters }}</p>
            </div>
        </button>

        <button class="hc__btn"
                :class="{
            'hc__active': category === ENUM.NEWSLETTERS.CATEGORIES.SPAMS,
            'text-lMedium': category !== ENUM.NEWSLETTERS.CATEGORIES.SPAMS,
            'text-lSemibold': category === ENUM.NEWSLETTERS.CATEGORIES.SPAMS,
        }"
                @click="updateCategory(ENUM.NEWSLETTERS.CATEGORIES.SPAMS)">
            <p class="mr__6">{{ $t('spam') }}</p>
            <div class="hc__highlight">
                <p class="text-baseMedium">{{ countSpams }}</p>
            </div>
        </button>
    </div>

</template>

<script>
import ENUM from '@/assets/ENUM'

import Subscription from '@/helpers/subscription'

import Tag from '@/modules/tag'

export default {

    name: 'newsletters-header-categories',

    props: {

        category: {
            type: String,
            default: ''
        },


        subscriptions: {
            type: Array,
            default: () => []
        },
    },

    computed: {
        ENUM() {
            return ENUM
        },

        Subscription() {
            return Subscription
        },

        countTotal() {
            return this.subscriptions && this.subscriptions.length
        },

        countNewsletters() {
            return this.countTotal - this.countSpams
        },

        countSpams() {
            return this.subscriptions && this.subscriptions.filter(subscription => Subscription.isSpoum(subscription)).length
        },
    },

    methods: {
        updateCategory(newCategory) {
            switch (newCategory) {
                case ENUM.NEWSLETTERS.CATEGORIES.ALL:
                    Tag.pageViewGA(this, 'tab_all')
                    break
                case ENUM.NEWSLETTERS.CATEGORIES.SUBSCRIPTIONS:
                    Tag.pageViewGA(this, 'tab_newsletters')
                    break
                case ENUM.NEWSLETTERS.CATEGORIES.SPAMS:
                    Tag.pageViewGA(this, 'tab_spams')
                    break
            }
            this.$emit('updateCategory', newCategory)
        }
    }
}
</script>

<style lang="scss" scoped>

.hc {

    display: flex;
    flex-direction: row;

    &__btn {
        display: flex;
        flex: 1;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        background-color: $timberwolf;
        padding: 8px 16px;
        border-bottom: 2px solid $timberwolf;

        @media screen and (min-width: $above-tablet-length) {
            border-bottom: none;
            background-color: $white;
        }
    }

    &__active {
        border-bottom: 2px solid $aquamarine;
        @media screen and (min-width: $above-tablet-length) {
            border-bottom: none;
            background-color: $timberwolf;
            border-radius: 72px;
        }
    }

    &__highlight {
        padding: 4px;
        background-color: $aquamarine;
        color: $white;
        border-radius: 72px;
        min-width: 24px;
    }
}
</style>
